export default __webpack_public_path__ + "static/media/kentron_original.31699bc6.png";